import {RecurlyErrorType} from 'desktop/types/recurlyTypes';

/**
 * Gets the error message element (for ui and analytics)
 * @param {RecurlyErrorType} error - recurly error
 * @returns {string} - error message
 */
export const getUserFrendlyRecurlyError = (error: RecurlyErrorType) => {
    let errorMessage = error.message || 'Unknown error';
    if (error.fields.includes('number')) errorMessage = 'Card number is invalid';

    if (error.fields.includes('postal_code')) errorMessage = 'Postal code is invalid';

    if (error.fields.includes('month') || error.fields.includes('year'))
        errorMessage = 'Month and year are invalid';

    if (error.fields.includes('cvv')) errorMessage = 'CVV is invalid';

    return errorMessage;
};
